const typography = {
  fontFamily: "'Lato', sans-serif",

  h3: {
    fontWeight: 700,
  },

  h4: {
    fontWeight: 700,
  },

  h5: {
    fontWeight: 600,
  },

  h6: {
    fontWeight: 600,
  },

  button: {
    textTransform: "none",
    fontWeight: 600,
  },
};

export default typography;
